{
  "id": "oryza",
  "name": "Gramene Oryza",
  "version": "v6",
  "description": "Comparative plant genomics focused on rice varieties",
  "url": "https://oryza.gramene.org",
  "ensemblURL": "https://oryza-ensembl.gramene.org",
  "ensemblSite": "https://oryza-ensembl.gramene.org",
  "ensemblRest": "https://data.gramene.org/pansite-ensembl-87",
  "grameneData": "https://data.gramene.org/oryza_v5",
  "curation": {
    "url": "http://curate.gramene.org/oryza_v5?since=4479&gene=",
    "taxa": {
      "39947": "Oryza sativa Japonica",
      "65489": "oryza_barthii",
      "4533": "oryza_brachyantha",
      "39947013": "oryza_carolina",
      "4538": "oryza_glaberrima",
      "40148": "oryza_glumaepatula",
      "39946": "oryza_indica",
      "1324417": "oryza_indicair8",
      "40149": "oryza_meridionalis",
      "4536": "oryza_nivara",
      "4537": "oryza_punctata",
      "4529": "oryza_rufipogon",
      "1736659": "oryza_aus",
      "39947002": "oryza_sativa117425",
      "39947003": "oryza_sativa125619",
      "39947004": "oryza_sativa125827",
      "39947005": "oryza_sativa127518",
      "39947006": "oryza_sativa127564",
      "39947007": "oryza_sativa127652",
      "39947008": "oryza_sativa127742",
      "39947009": "oryza_sativa128077",
      "39947010": "oryza_sativa132278",
      "39947011": "oryza_sativa132424",
      "39947001": "oryza_sativaazucena",
      "39947012": "oryza_sativair64",
      "39947014": "oryza_sativamh63",
      "39947015": "oryza_sativazs97",
      "39947016": "oryza_sativakitaake"
    }
  },
  "targetTaxonId": 39946,
  "portals": ['browser','blast','pansites'],
  "portals2": ['pansites','browser','reactome','blast','atlas','trackhub'],
  "showInMenu": true,
  "showNews": true,
  "showGuides": true,
  "showFeed": true,
  "showTweets": true,
  "date": "2023-01-16",
  "slides": []
}
